<script lang="ts" setup>
import { useForm } from '@inertiajs/vue3';
import type { Agency, SubscriberList } from 'types';
import { route } from '../composables/routes';
import Autocomplete from './Autocomplete.vue';
import FormField from './FormField.vue';
import FormLayout from './FormLayout.vue';

const props = defineProps<{
    agency: Agency;
    list: SubscriberList;
    moveAgencies?: Agency[];
}>();

const form = useForm({
    agency_id: null as number | null,
});

function onSubmit() {
    form.put(route('agencies.lists.move', {
        agency: props.agency.id,
        list: props.list.id,
    }));
}
</script>

<template>
    <div class="w-[25rem]">
        <div class="flex flex-col gap-y-1">
            <h2 class="text-3xl font-semibold">
                Move to Agency
            </h2>
            <p class="text-sm text-neutral-500 dark:text-neutral-400">
                The list's sends, subscribers and templates move with it, and users assigned to the list keep their access.
            </p>
        </div>

        <FormLayout
            :submit="onSubmit"
            :button-block="true"
            button-label="Move List"
            :disabled="form.processing || !form.agency_id"
            :activity="form.processing">
            <FormField
                label="Agency"
                description="Only agencies on this list's MessageGears instance are shown."
                block>
                <Autocomplete
                    id="agency_id"
                    v-model="form.agency_id"
                    name="agency_id"
                    namespace="move-agencies"
                    only="moveAgencies"
                    :response="moveAgencies"
                    :error="form.errors.agency_id" />
            </FormField>
        </FormLayout>
    </div>
</template>
